import z from "zod";

/** Spread into every LOB's contact schema. Optional everywhere — a submission reaches a bound
 *  policy without any of it, and these only save the operator retyping at Add User time. */
export const InsuredContactShape = {
	insuredContactName: z.string().describe("the name of the person at the insured who is the point of contact for this policy. This is someone at the insured, never the broker or anyone at the brokerage. Set to null if not stated.").nullable().default(null),
	insuredContactEmail: z.string().describe("the email address of the point of contact at the insured. Never the broker's email, and never a classa.ai address. Set to null if not stated.").nullable().default(null),
	insuredContactPhone: z.string().describe("the phone number of the insured or of its point of contact. Never the brokerage's phone number. Set to null if not stated.").nullable().default(null),
};

export const InsuredContactSchema = z.object(InsuredContactShape);

export type InsuredContact = z.output<typeof InsuredContactSchema>;
